import {Switch} from '@wandb/components';
import React from 'react';
import {twMerge} from 'tailwind-merge';

export const SettingLogToggle = ({
  id,
  className,
  isChecked,
  onCheckedChange,
}: {
  id?: string;
  className?: string;
  isChecked: boolean;
  onCheckedChange: (newValue: any) => void;
}) => {
  return (
    <div className={twMerge('flex items-center gap-8', className)}>
      <Switch id={id} compact isSelected={isChecked} onChange={onCheckedChange}>
        Log scale
      </Switch>
    </div>
  );
};
